'use strict';
(() => {
 const focusRoot=document.documentElement;
 focusRoot.classList.add('nhny-pointer-focus');
 document.addEventListener('pointerdown',()=>focusRoot.classList.add('nhny-pointer-focus'),{capture:true,passive:true});
 document.addEventListener('keydown',()=>focusRoot.classList.remove('nhny-pointer-focus'),true);
 const root=window.Shopify?.routes?.root||'/';
 const dialogs=[...document.querySelectorAll('dialog[id^="nhny-"]')];
 let previousOverflow='',returnFocus=null;
 let closingBag=false;
 const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
 const money=(value,currency)=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(value/100);
 const escape=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const ss27WelcomeDialog=document.querySelector('#nhny-ss27[data-ss27-welcome]');
 const ss27SeenKey='nhny-ss27-welcome-v1';
 let ss27WelcomePending=Boolean(ss27WelcomeDialog);
 try{if(sessionStorage.getItem(ss27SeenKey)==='seen')ss27WelcomePending=false;}catch{}
 async function request(path,options={}){
  const response=await fetch(root+path,{credentials:'same-origin',...options});
  const result=await response.json();
  if(!response.ok)throw new Error(result.description||result.message||'Unable to update your bag. Please try again.');
  return result;
 }
 const pendingCartQuantities=new Map();
 let changingCart=false,cartSnapshot=null,cartRenderId=0,cartChangeError='',cartNeedsRefresh=false;
 function syncCartPending(){
  const pending=changingCart||pendingCartQuantities.size>0;
  document.querySelector('[data-cart-lines]').setAttribute('aria-busy',String(pending));
  document.querySelectorAll('[data-cart-step]').forEach(button=>{
   const key=button.dataset.lineKey,quantity=pendingCartQuantities.get(key)??Number(button.dataset.quantity);
   button.dataset.quantity=String(quantity);
   button.disabled=quantity===0||Number(button.dataset.cartStep)<0&&quantity<=1;
   const row=button.closest('.bag-item');
   row.setAttribute('aria-busy',String(pendingCartQuantities.has(key)));
   row.querySelector('output').textContent=quantity;
   row.querySelector('[data-remove-line]').disabled=quantity===0;
  });
  document.querySelector('.bag-checkout').setAttribute('aria-disabled',String(pending||cartNeedsRefresh||!cartSnapshot?.item_count));
  document.querySelector('[data-cart-error]').textContent=cartChangeError;
 }
 async function renderCart(cart){
  const id=++cartRenderId;
  cart=cart||await request('cart.js');
  if(id!==cartRenderId)return;
  cartSnapshot=cart;cartNeedsRefresh=false;paintCart(cart);
 }
 function paintCart(cart){
  document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count||'');
  document.querySelector('[data-cart-count-label]').textContent=`${cart.item_count} ${cart.item_count===1?'ITEM':'ITEMS'}`;
  document.querySelector('[data-cart-summary-count]').textContent=`${cart.item_count} ${cart.item_count===1?'item':'items'}`;
  document.querySelector('[data-cart-total]').textContent=money(cart.total_price,cart.currency);
  document.querySelector('[data-cart-lines]').innerHTML=cart.items.length?cart.items.map(item=>`<article class="bag-item bag-glass">${item.image?`<a class="bag-item-photo" href="${escape(item.url)}"><img src="${escape(item.image)}" alt="${escape(item.product_title)}" width="72" height="90"></a>`:''}<div class="bag-item-info"><a class="bag-item-name" href="${escape(item.url)}">${escape(item.product_title)}</a><p class="bag-item-price">${money(item.final_line_price,cart.currency)}</p><p class="bag-item-variant">${escape(item.variant_title==='Default Title'?'One size':item.variant_title)}</p><div class="bag-item-actions"><div class="bag-quantity" role="group" aria-label="Quantity of ${escape(item.product_title)}"><button type="button" data-cart-step="-1" data-line-key="${escape(item.key)}" data-quantity="${item.quantity}" aria-label="Decrease quantity of ${escape(item.product_title)}" ${item.quantity<=1?'disabled':''}>-</button><output aria-label="Quantity">${item.quantity}</output><button type="button" data-cart-step="1" data-line-key="${escape(item.key)}" data-quantity="${item.quantity}" aria-label="Increase quantity of ${escape(item.product_title)}">+</button></div><button class="bag-remove" type="button" data-remove-line="${escape(item.key)}" aria-label="Remove ${escape(item.product_title)}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M9 6V3h6v3M6 6l1 15h10l1-15M10 10v7M14 10v7"/></svg></button></div></div></article>`).join(''):'<div class="bag-empty bag-glass"><p>Your bag is empty.</p><button type="button" data-continue-shopping>CONTINUE SHOPPING</button></div>';
  document.querySelectorAll('[data-recommendation-handle]').forEach(el=>el.hidden=cart.items.some(item=>item.handle===el.dataset.recommendationHandle));
  syncCartPending();
 }
 async function openDialog(id,trigger){
  const dialog=document.getElementById(id);if(!dialog)return;
  if(dialogs.some(d=>d.open))return;
  returnFocus=trigger;previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
  dialog.showModal();
  if(id==='nhny-ss27'){
   ss27WelcomePending=false;
   try{sessionStorage.setItem(ss27SeenKey,'seen');}catch{}
   dialog.querySelector('.ss27-modal-close').focus({preventScroll:true});
  }
  if(id==='nhny-bag'&&!reducedMotion.matches)dialog.animate([{opacity:0,transform:'translateX(calc(100% + 24px))'},{opacity:1,transform:'translateX(0)'}],{duration:380,easing:'cubic-bezier(.22,1,.36,1)'});
  if(id==='nhny-bag')try{await renderCart();}catch(error){document.querySelector('[data-cart-error]').textContent=error.message;}
 }
 document.addEventListener('nhny:cart-updated',()=>renderCart().catch(()=>{}));
 async function closeDialog(dialog){
  if(!dialog.open||dialog.id==='nhny-bag'&&closingBag)return;
  if(dialog.id==='nhny-bag'&&!reducedMotion.matches){
   closingBag=true;
   dialog.getAnimations().forEach(animation=>animation.cancel());
   try{await dialog.animate([{opacity:1,transform:'translateX(0)'},{opacity:0,transform:'translateX(calc(100% + 24px))'}],{duration:240,easing:'cubic-bezier(.4,0,1,1)',fill:'forwards'}).finished;}catch{}
  }
  dialog.close();
  dialog.getAnimations().forEach(animation=>animation.cancel());
  closingBag=false;
 }
 dialogs.forEach(dialog=>{
  dialog.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',()=>closeDialog(dialog)));
  dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;returnFocus?.focus({preventScroll:true});});
  if(dialog.id==='nhny-bag')dialog.addEventListener('cancel',event=>{event.preventDefault();closeDialog(dialog);});
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDialog(dialog);});
 });
 if(ss27WelcomePending){
  let ready=false;
  const showSs27Welcome=()=>{
   if(!ready||!ss27WelcomePending||document.hidden||document.querySelector('dialog[open]')||document.activeElement?.matches('input,textarea,select'))return;
   openDialog('nhny-ss27',document.activeElement);
  };
  setTimeout(()=>{ready=true;showSs27Welcome();},900);
  document.addEventListener('close',showSs27Welcome,true);
  document.addEventListener('visibilitychange',showSs27Welcome);
  document.addEventListener('focusout',()=>requestAnimationFrame(showSs27Welcome));
 }
 document.addEventListener('pointerdown',event=>{
  if(event.target.closest('.ss27-teaser .klaviyo-phoneinput [role="option"]'))event.preventDefault();
 },true);
 let pendingSignup=null;
 document.addEventListener('click',event=>{
  if(event.target.closest('.klaviyo-form-TwPxmj button[type="submit"]'))pendingSignup=event.target.closest('.ss27-teaser, .community-signup-dialog');
 },true);
 document.addEventListener('submit',event=>{
  if(event.target.matches('.klaviyo-form-TwPxmj form'))pendingSignup=event.target.closest('.ss27-teaser, .community-signup-dialog');
 },true);
 window.addEventListener('klaviyoForms',event=>{
  if(event.detail?.type!=='submit'||event.detail?.formId!=='TwPxmj'||!pendingSignup)return;
  const section=pendingSignup;
  pendingSignup=null;
  const embed=section.querySelector('.klaviyo-form-TwPxmj');
  const showConfirmation=()=>{
   if(embed.querySelector('input:not([type="hidden"])'))return;
   section.querySelector('.nhny-signup-confirmation').hidden=false;
   section.classList.add('ss27-confirmed');
   observer.disconnect();
  };
  const observer=new MutationObserver(showConfirmation);
  observer.observe(embed,{childList:true,subtree:true});
  showConfirmation();
 });
 document.addEventListener('click',event=>{
  const trigger=event.target.closest('[data-open]');if(!trigger||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
  event.preventDefault();openDialog(trigger.dataset.open,trigger);
 });
 document.querySelectorAll('[data-mobile-view]').forEach(tab=>tab.addEventListener('click',()=>{
  document.querySelectorAll('[data-mobile-view]').forEach(other=>{if(other===tab)other.setAttribute('aria-current','page');else other.removeAttribute('aria-current');});
  document.querySelectorAll('[data-mobile-panel]').forEach(panel=>{panel.hidden=panel.dataset.mobilePanel!==tab.dataset.mobileView;});
  document.querySelector('.nhny-mobile-body').scrollTop=0;
 }));
 const hero=document.querySelector('.hero');
 function updateHeader(){const solid=!hero||hero.getBoundingClientRect().bottom<=72;document.querySelector('#header').classList.toggle('header-solid',solid);document.body.classList.toggle('nav-surface-solid',solid);document.querySelector('.banner-flash').classList.toggle('banner-solid',solid);const logo=document.querySelector('#logo'),panther=document.body.classList.contains('template-collection');const source=solid&&!panther?logo.dataset.logoSolid:logo.dataset.logoHero;if(logo.src!==source)logo.src=source;}
 window.addEventListener('scroll',updateHeader,{passive:true});window.addEventListener('resize',updateHeader);updateHeader();
 const mobileHeader=matchMedia('(max-width:680px)'),searchLink=document.querySelector('.nhny-search-link');
 function placeSearch(){(mobileHeader.matches?document.querySelector('.header-links'):document.querySelector('.utilities')).prepend(searchLink);if(mobileHeader.matches)document.querySelector('.header-links').append(searchLink);}
 placeSearch();mobileHeader.addEventListener('change',placeSearch);
 function watchVisibleVideos(videos,sourceKey,margin=0,visibilityEvent){
  if(!videos.length)return;
  // The fixed hero video stays in the viewport after its section scrolls away.
  const visibilityTarget=video=>video.id==='hero-video'?video.closest('.hero')||video:video;
  const states=new Map(videos.map(video=>[video,{source:video.dataset[sourceKey]||video.getAttribute('src'),loading:false,failed:false,cancel:null}]));
  let active=0,syncing=false;
  const sync=()=>{
   if(syncing)return;syncing=true;
   try{
    const enabled=!document.hidden&&!reducedMotion.matches;
    const positions=videos.map(video=>{
     const rect=visibilityTarget(video).getBoundingClientRect();
     const shown=!video.closest('[hidden]')&&video.getClientRects().length>0&&rect.width>0&&rect.height>0;
     const horizontal=rect.right>0&&rect.left<innerWidth;
     return {video,near:enabled&&shown&&horizontal&&rect.bottom>-margin&&rect.top<innerHeight+margin,visible:enabled&&shown&&horizontal&&rect.bottom>0&&rect.top<innerHeight};
    });
    // Release cancelled slots before starting the next visible clips.
    positions.forEach(({video,near,visible})=>{
     const state=states.get(video);
     if(!visible)video.pause();
     if(!near){
      state.failed=false;
      if(state.loading){state.cancel();video.removeAttribute('src');video.preload='none';video.load();}
     }
    });
    positions.forEach(({video,near,visible})=>{
     const state=states.get(video);
     if(!near||state.loading||state.failed)return;
     if(video.readyState>=2){if(visible&&video.paused)video.play().catch(()=>{});return;}
     const source=states.get(video).source;
     if((!source&&!video.querySelector('source[src]'))||active>=3)return;
     active++;state.loading=true;
     let timer,settled=false;
     const cleanup=()=>{
      if(settled)return false;settled=true;
      state.loading=false;active--;clearTimeout(timer);
      video.removeEventListener('loadeddata',loaded);video.removeEventListener('error',failed);
      return true;
     };
     const loaded=()=>{if(!cleanup())return;video.preload='none';sync();};
     const failed=()=>{if(!cleanup())return;state.failed=true;video.pause();video.removeAttribute('src');video.preload='none';video.load();sync();};
     state.cancel=cleanup;
     video.addEventListener('loadeddata',loaded,{once:true});
     video.addEventListener('error',failed,{once:true});
     timer=setTimeout(failed,30000);
     video.preload='auto';video.muted=true;if(source)video.src=source;video.load();
    });
   }finally{syncing=false;}
  };
  if('IntersectionObserver' in window){
   const visibleObserver=new IntersectionObserver(sync);
   videos.forEach(video=>visibleObserver.observe(visibilityTarget(video)));
   if(margin){const nearObserver=new IntersectionObserver(sync,{rootMargin:`${margin}px 0px`});videos.forEach(video=>nearObserver.observe(visibilityTarget(video)));}
  }else{
   let scheduled=false;
   window.addEventListener('scroll',()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;sync();});},{passive:true});
  }
  window.addEventListener('resize',sync);
  document.addEventListener('visibilitychange',sync);
  reducedMotion.addEventListener('change',sync);
  if(visibilityEvent)document.addEventListener(visibilityEvent,sync);
  sync();
 }
 const feedVideos=[...document.querySelectorAll('#feed video')];
 watchVisibleVideos(feedVideos,'feedSrc',200,'nhny:feed-visibility');
 watchVisibleVideos([...document.querySelectorAll('#hero-video')],'heroSrc');
 document.querySelectorAll('.card-image:has(.image-arrow)').forEach(frame=>{
  const images=[...frame.querySelectorAll('a img')];let index=0;
  const loadImage=image=>{if(image?.dataset.src){image.src=image.dataset.src;delete image.dataset.src;}};
  frame.addEventListener('pointerenter',()=>loadImage(images[1]),{once:true});
  frame.querySelectorAll('.image-arrow').forEach(button=>button.addEventListener('click',event=>{
   event.preventDefault();index=(index+(button.classList.contains('next')?1:-1)+images.length)%images.length;
   loadImage(images[index]);
   images.forEach((image,n)=>{if(n>0)image.classList.toggle('is-visible',n===index);});
  }));
 });
 const shopCards=[...document.querySelectorAll('.nhny-shop-grid .card')];
 const bundleHandles=new Set(['arcus-set','fawn','the-serpent','black-system','belt-set','stripe-mark','stack-or-starve-hat-pack']);
 document.querySelectorAll('[data-shop-filter]').forEach(button=>button.addEventListener('click',()=>{
  const filter=button.dataset.shopFilter,bundles=filter==='bundles',newItems=filter==='new';let count=0;
  const grid=document.querySelector('.nhny-shop-grid'),preview=document.querySelector('#shop-ss27-preview');
  grid.hidden=newItems;preview.hidden=!newItems;
  shopCards.forEach(card=>{card.hidden=bundles&&!bundleHandles.has(card.dataset.productHandle);if(!card.hidden)count++;});
  document.querySelectorAll('[data-shop-filter]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
  document.querySelector('.nhny-shop h1').textContent=newItems?'SS27':'SHOP';
  document.querySelector('.shop-count').textContent=newItems?'COMING SOON':`${count} ${count===1?'product':'products'}`;
 }));
 const category=new URLSearchParams(location.search).get('category');
 if(category&&shopCards.length){
  const categoryPatterns={headgear:/trucker|hat|cap|beanie/,hats:/trucker|hat|cap|beanie/,caps:/trucker|hat|cap/,beanies:/beanie/,tops:/jacket|jersey|shirt|knit|hoodie|tee|^00-knit-v4$/,jackets:/jacket/,jerseys:/jersey/,shirts:/shirt/,knits:/knit|^00-knit-v4$/,hoodies:/hoodie/,tees:/tee/,belts:/belt/,accessories:/belt/,bottoms:/shorts|sweats/,shorts:/shorts/,sweats:/sweats/};
  const matches=(handle,type)=>type==='bundles'?bundleHandles.has(handle):!bundleHandles.has(handle)&&(categoryPatterns[type]?.test(handle)||false);
  let count=0;
  shopCards.forEach(card=>{card.hidden=!matches(card.dataset.productHandle||'',category);if(!card.hidden)count++;});
  const label=({headgear:'HATS',hats:'HATS',caps:'CAPS',beanies:'BEANIES',tops:'TOPS',jackets:'JACKETS',jerseys:'JERSEYS',shirts:'SHIRTS',knits:'KNITS',hoodies:'HOODIES',tees:'TEES',belts:'ACCESSORIES',accessories:'ACCESSORIES',bottoms:'BOTTOMS',shorts:'SHORTS',sweats:'SWEATS',bundles:'BUNDLES'})[category];
  if(label){
   const heading=document.querySelector('.nhny-shop h1');if(heading)heading.textContent=label;
   document.querySelectorAll('[data-shop-filter]').forEach(button=>button.setAttribute('aria-pressed','false'));
  }
  const counter=document.querySelector('.shop-count');if(counter)counter.textContent=`${count} ${count===1?'product':'products'}`;
 }
 const aboutVideos=[...document.querySelectorAll('[data-about-src]')];
 watchVisibleVideos(aboutVideos,'aboutSrc');
 document.querySelectorAll('.quick-add').forEach(trigger=>{
  const panel=trigger.parentElement.querySelector('.inline-sizes');
  if(!panel)return;
  const frame=trigger.closest('.card-image'),desktop=matchMedia('(min-width:681px) and (hover:hover) and (pointer:fine)');
  const toggle=open=>{panel.inert=!open;panel.classList.toggle('is-open',open);trigger.setAttribute('aria-expanded',String(open));};
  trigger.addEventListener('click',()=>{
   const choices=[...panel.querySelectorAll('[data-variant-id]')].filter(button=>!button.disabled&&button.dataset?.soldOut!=='true');
   if(!desktop.matches&&!trigger.dispatchEvent(new CustomEvent('nhny:quick-view',{bubbles:true,cancelable:true})))toggle(false);
   else if(choices.length===1&&panel.querySelectorAll('[data-variant-id]').length===1)choices[0].click();
   else toggle(!panel.classList.contains('is-open'));
  });
  frame?.addEventListener('pointerenter',()=>{if(desktop.matches)toggle(true);});
  frame?.addEventListener('pointerleave',()=>{if(desktop.matches&&!frame.matches(':focus-within'))toggle(false);});
  frame?.addEventListener('focusin',()=>{if(desktop.matches)toggle(true);});
  frame?.addEventListener('focusout',()=>setTimeout(()=>{if(!frame.matches(':focus-within'))toggle(false);},0));
  desktop.addEventListener('change',()=>toggle(false));
 });
 const addingForms=new WeakSet(),refreshAddState=new WeakMap();
 async function addProduct(form,button=form.querySelector('[type="submit"]')){
  const status=form.querySelector('[role="status"]');
  if(addingForms.has(form)||button.disabled||!form.reportValidity())return;
  addingForms.add(form);button.disabled=true;refreshAddState.get(form)?.();
  status.textContent='Adding to bag...';
  try{await request('cart/add.js',{method:'POST',body:new FormData(form)});status.textContent='';await openDialog('nhny-bag',button);}
  catch(error){status.textContent=error.message;}
  finally{addingForms.delete(form);const refresh=refreshAddState.get(form);if(refresh)refresh();else button.disabled=false;}
 }
 document.querySelectorAll('.nhny-add-form').forEach(form=>{
  form.addEventListener('submit',event=>{
   if(event.submitter?.closest('.shopify-payment-button'))return;
   event.preventDefault();
    if(addingForms.has(form))return;
   if(form.classList.contains('nhny-product-form')&&form.dataset.selectionMade!=='true'){
    form.querySelector('.nhny-form-status').textContent='Select '+(form.querySelectorAll('.product-options').length>1?'options':'a size')+' first.';
    form.querySelector('.product-size-row button:not(:disabled)')?.focus();return;
   }
   addProduct(form,event.submitter||undefined);
  });
  form.querySelectorAll('[data-variant-id]').forEach(button=>button.addEventListener('click',()=>{
   form.querySelector('input[name="id"]').value=button.dataset.variantId;
   if(button.dataset.soldOut==='true')button.dispatchEvent(new CustomEvent('nhny:quick-view',{bubbles:true,cancelable:true,detail:{variantId:button.dataset.variantId}}));
  }));
 });
 const productForm=document.querySelector('.nhny-product-form');
 if(productForm){
  const product=JSON.parse(document.querySelector('[data-nhny-product]').textContent);
  const selection=productForm.querySelector('[data-product-selection]'),add=productForm.querySelector('.product-add');
  const notify=document.querySelector('[data-product-notify]');
  const choices=Array(product.options.length).fill(null);
  const updateAddState=()=>{
   const variant=product.variants.find(item=>String(item.id)===selection.value),pending=addingForms.has(productForm);
   add.textContent=pending?'ADDING TO BAG...':variant?.available?'ADD TO CART':variant?'SOLD OUT':choices.every(Boolean)?'UNAVAILABLE':choices.length>1?'SELECT OPTIONS':'SELECT SIZE';
   add.disabled=pending||!!variant&&!variant.available||!product.variants.some(item=>item.available);
  };
  refreshAddState.set(productForm,updateAddState);
  const selectVariant=variant=>{
   selection.value=variant?.id||'';
   productForm.dataset.selectionMade=String(!!variant?.available);
   if(notify)notify.hidden=!variant||variant.available;
   const express=productForm.querySelector('.product-express');if(express)express.inert=!variant?.available;
   updateAddState();
   if(variant)document.querySelector('[data-product-price]').textContent=money(variant.price,window.Shopify?.currency?.active||'AUD');
   selection.dispatchEvent(new Event('change',{bubbles:true}));
   if(!addingForms.has(productForm))productForm.querySelector('.nhny-form-status').textContent='';
  };
  productForm.querySelectorAll('[data-product-variant]').forEach(button=>button.addEventListener('click',()=>{
   productForm.querySelectorAll('[data-product-variant]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
   selectVariant(product.variants.find(variant=>String(variant.id)===button.dataset.productVariant));
  }));
  productForm.querySelectorAll('[data-product-option]').forEach(button=>{
   const index=Number(button.dataset.productOption),value=button.dataset.optionValue;
   if(!product.variants.some(variant=>variant.available&&variant.options[index]===value)){button.dataset.soldOut='true';button.setAttribute('aria-label',`${value}, sold out`);}
   button.addEventListener('click',()=>{
    choices[index]=value;
    productForm.querySelectorAll(`[data-product-option="${index}"]`).forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
    selectVariant(choices.every(Boolean)?product.variants.find(variant=>choices.every((choice,i)=>variant.options[i]===choice)):null);
   });
  });
  const variants=productForm.querySelectorAll('[data-product-variant]');
  if(variants.length===1&&!variants[0].disabled)variants[0].click();
  else if(choices.length>1)selectVariant(null);
  productForm.querySelectorAll('[data-product-step]').forEach(button=>button.addEventListener('click',()=>{
   const input=productForm.querySelector('input[name="quantity"]'),quantity=Math.max(1,Math.min(10,Number(input.value)+Number(button.dataset.productStep)));
   input.value=quantity;productForm.querySelector('output').textContent=quantity;
   productForm.querySelector('[data-product-step="-1"]').disabled=quantity===1;
  }));
  const titleRow=document.querySelector('.product-title-row'),paymentNote=document.querySelector('.product-payment-note');
  const movePayment=()=>{const placement=titleRow.querySelector('square-placement');if(placement)paymentNote.append(placement);};
  new MutationObserver(movePayment).observe(titleRow,{childList:true});movePayment();
 }
 async function flushCartChanges(){
  if(changingCart)return;changingCart=true;syncCartPending();
  try{
   do{
    let cart;
    while(pendingCartQuantities.size){
     const [key,quantity]=pendingCartQuantities.entries().next().value;
     try{cart=await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});}
     catch(error){if(pendingCartQuantities.get(key)===quantity)cartChangeError=error.message;}
     if(pendingCartQuantities.get(key)===quantity)pendingCartQuantities.delete(key);
    }
    try{await renderCart(cartChangeError?undefined:cart);}
    catch(error){cartChangeError=error.message;cartNeedsRefresh=true;if(cartSnapshot)paintCart(cartSnapshot);}
   }while(pendingCartQuantities.size);
  }finally{changingCart=false;syncCartPending();}
 }
 function changeLine(key,quantity){
  if(!key||!Number.isInteger(quantity)||quantity<0)return;
  pendingCartQuantities.set(key,quantity);cartChangeError='';syncCartPending();
  return flushCartChanges();
 }
 document.querySelector('#nhny-bag').addEventListener('click',async event=>{
  const target=event.target.closest('button,a');if(!target||target.disabled)return;
  if(target.matches('.bag-checkout[aria-disabled="true"]')){event.preventDefault();return;}
  if(target.matches('[data-continue-shopping]')){closeDialog(document.querySelector('#nhny-bag'));return;}
  if(target.matches('[data-remove-line]')){changeLine(target.dataset.removeLine,0);return;}
  if(target.matches('[data-cart-step]')){const key=target.dataset.lineKey;changeLine(key,(pendingCartQuantities.get(key)??Number(target.dataset.quantity))+Number(target.dataset.cartStep));return;}
  if(target.matches('[data-bag-size-toggle]')){const panel=target.nextElementSibling;panel.hidden=!panel.hidden;target.setAttribute('aria-expanded',String(!panel.hidden));return;}
  if(target.matches('[data-bag-add-variant]')){
   target.disabled=true;
   try{await request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(target.dataset.bagAddVariant),quantity:1})});await renderCart();}
   catch(error){document.querySelector('[data-cart-error]').textContent=error.message;}
   finally{target.disabled=false;}
  }
 });
 document.querySelectorAll('.mobile-product-carousel').forEach(track=>{
  let drag;
  track.addEventListener('dragstart',event=>event.preventDefault());
  track.addEventListener('pointerdown',event=>{if(event.pointerType==='mouse'&&event.button===0)drag={id:event.pointerId,x:event.clientX,scroll:track.scrollLeft,moved:false};});
  track.addEventListener('pointermove',event=>{if(!drag||drag.id!==event.pointerId)return;const delta=event.clientX-drag.x;if(Math.abs(delta)>5){drag.moved=true;track.setPointerCapture(event.pointerId);track.scrollLeft=drag.scroll-delta;}});
  track.addEventListener('click',event=>{if(drag?.moved){event.preventDefault();event.stopPropagation();drag=null;}},true);
  track.addEventListener('pointercancel',()=>{drag=null;});
 });
 const communityStrip=document.querySelector('.community-strip');
 if(communityStrip&&!communityStrip.id&&!communityStrip.closest('.nhny-community-page')){
  const communitySection=communityStrip.closest('.community');
  const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
  const syncCommunityScroll=()=>{
   if(reducedMotion.matches)return;
   const rect=communitySection.getBoundingClientRect();
   if(rect.top>=innerHeight||rect.bottom<=0)return;
   const overflow=communityStrip.scrollWidth-communityStrip.clientWidth;
   const progress=Math.max(0,Math.min(1,(innerHeight-rect.top)/(innerHeight+rect.height)));
   communityStrip.scrollLeft=overflow*progress;
  };
  window.addEventListener('scroll',syncCommunityScroll,{passive:true});
  window.addEventListener('resize',syncCommunityScroll);
  syncCommunityScroll();
  let drag;
  communityStrip.addEventListener('dragstart',event=>event.preventDefault());
  communityStrip.addEventListener('pointerdown',event=>{if(event.pointerType==='mouse'&&event.button===0)drag={id:event.pointerId,x:event.clientX,scroll:communityStrip.scrollLeft,moved:false};});
  communityStrip.addEventListener('pointermove',event=>{if(!drag||drag.id!==event.pointerId)return;const delta=event.clientX-drag.x;if(Math.abs(delta)>5){drag.moved=true;communityStrip.setPointerCapture(event.pointerId);communityStrip.scrollLeft=drag.scroll-delta;}});
  communityStrip.addEventListener('click',event=>{if(drag?.moved){event.preventDefault();event.stopPropagation();drag=null;}},true);
  communityStrip.addEventListener('pointercancel',()=>{drag=null;});
  communityStrip.addEventListener('wheel',event=>{
   if(event.ctrlKey)return;
   const delta=Math.abs(event.deltaX)>Math.abs(event.deltaY)?event.deltaX:event.deltaY;
   const amount=delta*(event.deltaMode===1?16:event.deltaMode===2?communityStrip.clientWidth:1);
   const before=communityStrip.scrollLeft,max=communityStrip.scrollWidth-communityStrip.clientWidth;
   if((amount>0&&before>=max-1)||(amount<0&&before<=1)||amount===0)return;
   event.preventDefault();communityStrip.scrollLeft=Math.max(0,Math.min(max,before+amount));
  },{passive:false});
 }
})();
